// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductList_pageWrap__OMPc- {
  padding: 4px 4px 32px;
}

/* =========================================================
   Toolbar (seller select + search)
   ========================================================= */
.ProductList_toolbarRow__BFOzq {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 18px 24px;
  border-bottom: 1px solid #EEF0F6;
}

.ProductList_sellerField__5kAj0 {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ProductList_sellerLabel__B6pP\\+ {
  font-size: 12.5px;
  font-weight: 700;
  color: #6B7280;
  white-space: nowrap;
}

.ProductList_sellerSelect__ICZS1 {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  min-width: 180px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.ProductList_sellerSelect__ICZS1:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.ProductList_searchGroup__EW4Ma {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
  max-width: 720px;
}

.ProductList_searchBox__diYly {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #FAFAFC;
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  padding: 8px 12px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.ProductList_searchBox__diYly:focus-within {
  border-color: #4c2fb3;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}
.ProductList_searchBox__diYly img {
  width: 14px;
  height: 14px;
  opacity: 0.6;
  flex-shrink: 0;
}
.ProductList_searchBox__diYly input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 13.5px;
  width: 100%;
}

/* =========================================================
   Bulk-selection bar
   ========================================================= */
.ProductList_bulkBar__KC94X {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
}

.ProductList_chipBtn__UDJkE {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #F3F4F6;
  color: #374151;
  border: none;
  border-radius: 20px;
  font-size: 12.5px;
  font-weight: 600;
  padding: 6px 16px;
  cursor: pointer;
  transition: background 0.15s ease;
  white-space: nowrap;
}
.ProductList_chipBtn__UDJkE:hover {
  background: #E5E7EB;
}

.ProductList_chipBtnPrimary__NCLlL {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
  border: none;
  border-radius: 20px;
  font-size: 12.5px;
  font-weight: 700;
  padding: 6px 18px;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(76, 47, 179, 0.24);
  transition: box-shadow 0.15s ease;
  white-space: nowrap;
}
.ProductList_chipBtnPrimary__NCLlL:hover {
  box-shadow: 0 10px 20px rgba(76, 47, 179, 0.3);
}

.ProductList_statusSelect__7h3KK {
  padding: 6px 12px;
  border-radius: 20px;
  border: 1px solid #E5E7EB;
  font-size: 12.5px;
  font-weight: 600;
  background: #ffffff;
  color: #374151;
}

/* =========================================================
   Table cell helpers — matches Brand.module.css's imageThumb /
   product name styling so this table looks the same as Brand's.
   ========================================================= */
.ProductList_productImage__MhfuN {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  object-fit: contain;
  border: 1px solid #E7E9F1;
  background: #FAFAFC;
  padding: 3px;
}

.ProductList_productName__gNZVC {
  color: #1F2430;
  font-weight: 700;
  font-family: 'Sora', 'Inter', sans-serif;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Tighter cell padding, scoped to this page only */
.ProductList_compactTable__GSHnx .custom-table th,
.ProductList_compactTable__GSHnx .custom-table td {
  padding: 8px 10px;
}

/* Deterministic column widths — table-layout:fixed sizes columns purely
   from these rules, ignoring content, so no browser auto-sizing quirk
   can reintroduce blank gaps. Counted from the end (nth-last-child) so
   the widths stay correct whether or not the bulk-select "Select"
   column is prepended. Only Name is left unconstrained, so it absorbs
   all the remaining width. */
.ProductList_compactTable__GSHnx .custom-table {
  table-layout: fixed;
  width: 100%;
}
.ProductList_compactTable__GSHnx .custom-table th:nth-last-child(1),
.ProductList_compactTable__GSHnx .custom-table td:nth-last-child(1) {
  width: 90px;
}
.ProductList_compactTable__GSHnx .custom-table th:nth-last-child(2),
.ProductList_compactTable__GSHnx .custom-table td:nth-last-child(2) {
  width: 100px;
}
.ProductList_compactTable__GSHnx .custom-table th:nth-last-child(3),
.ProductList_compactTable__GSHnx .custom-table td:nth-last-child(3) {
  width: 90px;
}
.ProductList_compactTable__GSHnx .custom-table th:nth-last-child(5),
.ProductList_compactTable__GSHnx .custom-table td:nth-last-child(5) {
  width: 70px;
}
.ProductList_compactTable__GSHnx .custom-table th:nth-last-child(6),
.ProductList_compactTable__GSHnx .custom-table td:nth-last-child(6) {
  width: 130px;
}
.ProductList_compactTable__GSHnx .custom-table th:nth-last-child(7),
.ProductList_compactTable__GSHnx .custom-table td:nth-last-child(7) {
  width: 50px;
}

.ProductList_productId__65GaD {
  font-size: 11.5px;
  color: #9CA3AF;
  font-weight: 500;
  margin-top: 3px;
}

/* =========================================================
   Floating selection toolbar (bulk-actions snackbar)
   ========================================================= */
.ProductList_selectionMsg__cXPA3 {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: #ffffff;
}
.ProductList_selectionMsg__cXPA3 strong {
  font-weight: 800;
}

.ProductList_selectionActions__jN\\+B0 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ProductList_selBtn__krbjQ {
  border: none;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 700;
  padding: 7px 16px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, transform 0.15s ease;
}
.ProductList_selBtn__krbjQ:hover {
  transform: translateY(-1px);
}
.ProductList_selBtnActivate__-Zn1g {
  background: #ffffff;
  color: #4c2fb3;
}
.ProductList_selBtnActivate__-Zn1g:hover {
  background: #ede9fb;
}
.ProductList_selBtnDeactivate__Zmoll {
  background: rgba(255, 255, 255, 0.16);
  color: #ffffff;
}
.ProductList_selBtnDeactivate__Zmoll:hover {
  background: rgba(255, 255, 255, 0.28);
}

.ProductList_selDivider__\\+CvUb {
  width: 1px;
  height: 22px;
  background: rgba(255, 255, 255, 0.28);
  margin: 0 2px;
}

.ProductList_selClose__sGVVw {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.ProductList_selClose__sGVVw:hover {
  background: rgba(255, 255, 255, 0.16);
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/productlist/ProductList.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,0DAA0D;AAC5D;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,8CAA8C;EAC9C,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;8DAG8D;AAC9D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,wCAAwC;EACxC,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;;EAEE,iBAAiB;AACnB;;AAEA;;;;;6BAK6B;AAC7B;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;8DAE8D;AAC9D;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,uDAAuD;AACzD;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,mDAAmD;AACrD;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n/* =========================================================\n   Toolbar (seller select + search)\n   ========================================================= */\n.toolbarRow {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 18px 24px;\n  border-bottom: 1px solid #EEF0F6;\n}\n\n.sellerField {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.sellerLabel {\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #6B7280;\n  white-space: nowrap;\n}\n\n.sellerSelect {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  min-width: 180px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.sellerSelect:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.searchGroup {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 10px;\n  max-width: 720px;\n}\n\n.searchBox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #FAFAFC;\n  border: 1px solid #E5E7EB;\n  border-radius: 10px;\n  padding: 8px 12px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.searchBox:focus-within {\n  border-color: #4c2fb3;\n  background: #ffffff;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n.searchBox img {\n  width: 14px;\n  height: 14px;\n  opacity: 0.6;\n  flex-shrink: 0;\n}\n.searchBox input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 13.5px;\n  width: 100%;\n}\n\n/* =========================================================\n   Bulk-selection bar\n   ========================================================= */\n.bulkBar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.chipBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #F3F4F6;\n  color: #374151;\n  border: none;\n  border-radius: 20px;\n  font-size: 12.5px;\n  font-weight: 600;\n  padding: 6px 16px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  white-space: nowrap;\n}\n.chipBtn:hover {\n  background: #E5E7EB;\n}\n\n.chipBtnPrimary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 20px;\n  font-size: 12.5px;\n  font-weight: 700;\n  padding: 6px 18px;\n  cursor: pointer;\n  box-shadow: 0 6px 14px rgba(76, 47, 179, 0.24);\n  transition: box-shadow 0.15s ease;\n  white-space: nowrap;\n}\n.chipBtnPrimary:hover {\n  box-shadow: 0 10px 20px rgba(76, 47, 179, 0.3);\n}\n\n.statusSelect {\n  padding: 6px 12px;\n  border-radius: 20px;\n  border: 1px solid #E5E7EB;\n  font-size: 12.5px;\n  font-weight: 600;\n  background: #ffffff;\n  color: #374151;\n}\n\n/* =========================================================\n   Table cell helpers — matches Brand.module.css's imageThumb /\n   product name styling so this table looks the same as Brand's.\n   ========================================================= */\n.productImage {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  object-fit: contain;\n  border: 1px solid #E7E9F1;\n  background: #FAFAFC;\n  padding: 3px;\n}\n\n.productName {\n  color: #1F2430;\n  font-weight: 700;\n  font-family: 'Sora', 'Inter', sans-serif;\n  width: 100%;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Tighter cell padding, scoped to this page only */\n.compactTable :global(.custom-table th),\n.compactTable :global(.custom-table td) {\n  padding: 8px 10px;\n}\n\n/* Deterministic column widths — table-layout:fixed sizes columns purely\n   from these rules, ignoring content, so no browser auto-sizing quirk\n   can reintroduce blank gaps. Counted from the end (nth-last-child) so\n   the widths stay correct whether or not the bulk-select \"Select\"\n   column is prepended. Only Name is left unconstrained, so it absorbs\n   all the remaining width. */\n.compactTable :global(.custom-table) {\n  table-layout: fixed;\n  width: 100%;\n}\n.compactTable :global(.custom-table th:nth-last-child(1)),\n.compactTable :global(.custom-table td:nth-last-child(1)) {\n  width: 90px;\n}\n.compactTable :global(.custom-table th:nth-last-child(2)),\n.compactTable :global(.custom-table td:nth-last-child(2)) {\n  width: 100px;\n}\n.compactTable :global(.custom-table th:nth-last-child(3)),\n.compactTable :global(.custom-table td:nth-last-child(3)) {\n  width: 90px;\n}\n.compactTable :global(.custom-table th:nth-last-child(5)),\n.compactTable :global(.custom-table td:nth-last-child(5)) {\n  width: 70px;\n}\n.compactTable :global(.custom-table th:nth-last-child(6)),\n.compactTable :global(.custom-table td:nth-last-child(6)) {\n  width: 130px;\n}\n.compactTable :global(.custom-table th:nth-last-child(7)),\n.compactTable :global(.custom-table td:nth-last-child(7)) {\n  width: 50px;\n}\n\n.productId {\n  font-size: 11.5px;\n  color: #9CA3AF;\n  font-weight: 500;\n  margin-top: 3px;\n}\n\n/* =========================================================\n   Floating selection toolbar (bulk-actions snackbar)\n   ========================================================= */\n.selectionMsg {\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: #ffffff;\n}\n.selectionMsg strong {\n  font-weight: 800;\n}\n\n.selectionActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.selBtn {\n  border: none;\n  border-radius: 999px;\n  font-size: 12.5px;\n  font-weight: 700;\n  padding: 7px 16px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s ease, transform 0.15s ease;\n}\n.selBtn:hover {\n  transform: translateY(-1px);\n}\n.selBtnActivate {\n  background: #ffffff;\n  color: #4c2fb3;\n}\n.selBtnActivate:hover {\n  background: #ede9fb;\n}\n.selBtnDeactivate {\n  background: rgba(255, 255, 255, 0.16);\n  color: #ffffff;\n}\n.selBtnDeactivate:hover {\n  background: rgba(255, 255, 255, 0.28);\n}\n\n.selDivider {\n  width: 1px;\n  height: 22px;\n  background: rgba(255, 255, 255, 0.28);\n  margin: 0 2px;\n}\n\n.selClose {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.85);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.selClose:hover {\n  background: rgba(255, 255, 255, 0.16);\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `ProductList_pageWrap__OMPc-`,
	"toolbarRow": `ProductList_toolbarRow__BFOzq`,
	"sellerField": `ProductList_sellerField__5kAj0`,
	"sellerLabel": `ProductList_sellerLabel__B6pP+`,
	"sellerSelect": `ProductList_sellerSelect__ICZS1`,
	"searchGroup": `ProductList_searchGroup__EW4Ma`,
	"searchBox": `ProductList_searchBox__diYly`,
	"bulkBar": `ProductList_bulkBar__KC94X`,
	"chipBtn": `ProductList_chipBtn__UDJkE`,
	"chipBtnPrimary": `ProductList_chipBtnPrimary__NCLlL`,
	"statusSelect": `ProductList_statusSelect__7h3KK`,
	"productImage": `ProductList_productImage__MhfuN`,
	"productName": `ProductList_productName__gNZVC`,
	"compactTable": `ProductList_compactTable__GSHnx`,
	"productId": `ProductList_productId__65GaD`,
	"selectionMsg": `ProductList_selectionMsg__cXPA3`,
	"selectionActions": `ProductList_selectionActions__jN+B0`,
	"selBtn": `ProductList_selBtn__krbjQ`,
	"selBtnActivate": `ProductList_selBtnActivate__-Zn1g`,
	"selBtnDeactivate": `ProductList_selBtnDeactivate__Zmoll`,
	"selDivider": `ProductList_selDivider__+CvUb`,
	"selClose": `ProductList_selClose__sGVVw`
};
export default ___CSS_LOADER_EXPORT___;
